import React from 'react';
import { DropzoneCaptionLeft } from './content-blocks/dropzone-caption-left';
import { DropzoneNoCaption } from './content-blocks/dropzone-no-caption';
import { PictureCover } from './content-blocks/picture-cover';
import { Styles } from './file-upload-view-multiline.styles';
import { FileUploadProps } from './types';

export const FileUploadViewMultiline: React.FC<FileUploadProps> = ({
  className,
  picCovers = [],
  inputProps,
  onRetryClick,
  onRemoveClick,
  onFileSelectionClick,
  onFilesSelect,
  ...htmlProps
}) => {
  const DropzoneView = picCovers.length > 0 ? DropzoneNoCaption : DropzoneCaptionLeft;
  const onRetryCb = React.useCallback(
    (src: string) => {
      onRetryClick?.(src);
    },
    [onRetryClick],
  );

  const onRemoveCb = React.useCallback(
    (src: string) => {
      onRemoveClick?.(src);
    },
    [onRemoveClick],
  );

  const picCavers = React.useMemo(
    () =>
      picCovers.map(({ src, isInProcessing, processingIsFailed }) => (
        <PictureCover
          key={src}
          src={src}
          onRetryClick={onRetryCb}
          onRemoveClick={onRemoveCb}
          isInProcessing={isInProcessing}
          processingIsFailed={processingIsFailed}
          data-qa="pic-cover_mf-pdp"
        />
      )),
    [picCovers, onRetryCb, onRemoveCb],
  );

  const onFileSelectionClickCb = React.useCallback(() => onFileSelectionClick?.(), [onFileSelectionClick]);

  return (
    <div className={className} {...htmlProps}>
      <div className={Styles.multilineLayout}>
        <>{picCavers}</>

        <div className={Styles.multilineDropzoneContainer} data-qa="dropzone-view-container_mf-pdp">
          <DropzoneView
            onClick={onFileSelectionClickCb}
            onFilesSelect={onFilesSelect}
            inputProps={inputProps}
            data-qa="dropzone-view_mf-pdp"
          />
        </div>
      </div>
    </div>
  );
};
